export enum CHECKOUT_STATES {
  INITIAL = 'INITIAL',
  CAN_CHECKOUT = 'CAN_CHECKOUT',
  STARTED = 'STARTED',
  WAITING_CART = 'WAITING_CART',
  POST_ADDRESS_SELECTED = 'POST_ADDRESS_SELECTED',
  POST_BILLING_ADDRESS_SELECTED = 'POST_BILLING_ADDRESS_SELECTED',
  ADDRESSED = 'ADDRESSED',
  SHIPPING_SKIPPED = 'SHIPPING_SKIPPED',
  SHIPPING_METHOD_SELECTED = 'SHIPPING_METHOD_SELECTED',
  POST_SHIPPING_SELECTED = 'POST_SHIPPING_SELECTED',
  SHIPPING_SELECTED = 'SHIPPING_SELECTED',
  PAYMENT_SKIPPED = 'PAYMENT_SKIPPED',
  PAYMENT_SELECTED = 'PAYMENT_SELECTED',
  CREATE_PAYMENT_INTENT = 'CREATE_PAYMENT_INTENT',
  COMPLETING_WITHOUT_PAYMENT = 'COMPLETING_WITHOUT_PAYMENT',
  COMPLETE = 'COMPLETE',
  ADDING_COUPON = 'ADDING_COUPON',
  POST_ADD_COUPON = 'POST_ADD_COUPON',
}
